import { primaryImageStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { css } from "styled-components";

primaryImageStyles.primaryImage = {
    centeringWrapper: {
        css: css`
        min-height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            height: auto;
            max-width: 100%;
        }
        height: 100%;
        `,
    }
}